require('./scrolloverflow');
require('./fullpage.scrollHorizontally');
require('./fullpage.responsiveSlides');
//require('./fullpage.scrollOverflowReset');
window.fullpage = require('./fullpage.js');

import Parallax from "./components/Parallax";
import Swipe from "./components/Swipe";
import SectionController from './components/SectionController'

$(document).ready(function () {

    $('.js-parallax')           .each(function() { new Parallax         ($(this)); });

    const CLASS_SECTION_WILL_BE_ANIMATED = 'section-will-be-animated';

    $('.js-treadmill-section').each(function() {

        var $section = $(this),
            controller = new SectionController($section),
            $animation = $('.js-section-3-animation'),
            sectionId = $section.attr('id');

        $section.addClass(CLASS_SECTION_WILL_BE_ANIMATED);

        controller.animateOnEnter = function() {
            $section.addClass('section-animation-on-enter');
            sectionHasBeenAnimated(controller.id, 'section-animation-on-enter')
        };

        controller.revertAnimateOnEnter = function() {
            $section.removeClass('section-animation-on-enter');
            sectionAnimationHasBeenReverted(controller.id)
        };

        controller.animateOnLeave = function() {
            $animation.addClass(sectionId + '-on-leave');
        };

        controller.revertAnimateOnLeave = function() {
            $animation.removeClass(sectionId + '-on-leave');
        };

        $section.data('controller', controller);
    });

    var $bg = $('.js-bg');

    var fullpageFirstLoad = true;
    var animatedSections = [];
    var fullpageElementId = '#js-fullpage';
    var scrollOverflow = !!$(fullpageElementId).data('scrolloverflow') && $(window).width() >= 768;
    var fullPageInstance = new window.fullpage(fullpageElementId, {
        anchors: ['anchor-section-1'],

        scrollingSpeed: 800,
        scrollBar: true,

        scrollHorizontally: true,

        responsiveWidth: 768,
        //responsiveHeight: 768,

        responsiveSlides: true,

        normalScrollElements: '.scrollable-content',

        scrollOverflow: scrollOverflow,
        //scrollOverflowReset: scrollOverflow,

        bigSectionsDestination: 'bottom',

        onSlideLeave: function(section, origin, destination, direction){
            //console.log('on slide leave', 'destination = ' + getSectionName(destination.item), 'origin = ' + getSectionName(origin.item), direction);
            handleMove(destination, origin, direction);
        },

        onLeave: function(origin, destination, direction){
            //console.log('on leave', 'destination = ' + getSectionName(destination.item), 'origin = ' + getSectionName(origin.item), direction);
            handleMove(destination, origin, direction);
        },

        afterLoad: function(origin, destination, direction){
            //console.log('after load', 'destination = ' + getSectionName(destination.item), 'origin = ' + getSectionName(origin.item), direction);
            //handleMove(destination, origin, direction);

            if (fullpageFirstLoad) {
                fullpageFirstLoad = false;
                afterFullpageInitCallback(destination);
            }

            if (destination.item === origin.item) {
                console.log('first load');
            }
        },

        afterSlideLoad: function(section, origin, destination, direction){
            //console.log('after slide load', 'destination = ' + getSectionName(destination.item), 'origin = ' + getSectionName(origin.item), direction);
            //handleMove(destination, origin, direction);
        },

        afterRender: function () {
            //console.log('after render', fullPageInstance, this);
        },
        //afterResize: function(width, height){},
        //afterReBuild: function(){},
        afterResponsive: function(isResponsive){
            console.log('after responsive, is responsive = ', isResponsive, this);
        },
    });

    function afterFullpageInitCallback(currentSection) {
//console.log('after init callback', 'current section = ' + getSectionName(currentSection.item), currentSection);

        if (!currentSection.isFirst) {
//console.log('need to play all previous animations');
            var hasToStop = false,
                prev = null;
            $('.section').each(function(i, section) {

                if (hasToStop) {
                    return;
                }

                var $section = $(section);

                animateSection($section, prev);

                prev = $section;

                if (section === currentSection.item) {
                    hasToStop = true;
                    return;
                }

                if ($section.find('.slide').length > 0) {
                    $section.find('.slide').each(function(j, slide) {

                        var $slide = $(slide);

                        animateSection($slide, prev);
                        prev = $slide;

                        if (slide === currentSection.item) {
                            hasToStop = true;
                            return;
                        }
                    });
                }
            });
        }
    }

    function animateSection(section, previous, direction) {
//console.log('need to animate section = ', getSectionName(section));
        direction = direction || 'down';

        handleMove({item: section}, {item: previous}, direction, true);
    }

    function handleMove(destination, origin, direction, dontRevert) {
//console.log(destination, origin);
        // плавная смена цвета страницы
        if (destination.item) {
            var $item = $(destination.item),
                bgColor = $item.data('bg-color');

            if (bgColor) {
                $bg.css({'background-color': bgColor});
            }
        }

        if (['up', 'down'].indexOf(direction) === -1) {
            console.warn('wrong direction');
        }
//console.log('direction = ', direction);
        var $sectionToGo = $(destination.item),
            $sectionToLeave = $(origin.item),
            sectionToGoCtrl = $sectionToGo.data('controller'),
            sectionToLeaveCtrl = $sectionToLeave.data('controller');

        if (['down', 'right'].indexOf(direction) !== -1) {
            if (sectionToGoCtrl && sectionToGoCtrl.onTopEnter) {
                sectionToGoCtrl.onTopEnter();
            }

            if (sectionToLeaveCtrl && sectionToLeaveCtrl.onBottomLeave) {
                sectionToLeaveCtrl.onBottomLeave();
            }
        } else if (['up', 'left'].indexOf(direction) !== -1) {
            if (sectionToGoCtrl && sectionToGoCtrl.onBottomEnter) {
                sectionToGoCtrl.onBottomEnter();
            }

            if (sectionToLeaveCtrl && sectionToLeaveCtrl.onTopLeave) {
                sectionToLeaveCtrl.onTopLeave();
            }

            if (!dontRevert) {
                // после скролла вверх, нужно убрать все анимации ниже текущей
                revertAnimationsBelow($sectionToGo);
            }
        }

        //console.table(animatedSections);
    }

    /**
     * Отменить все анимации в секциях ниже текущей
     *
     * @param $section
     */
    function revertAnimationsBelow($section) {

        //console.log('need to revert all animations below ' + getSectionName($section));
        //console.table(animatedSections);
        /*
        if ($section.is('.section')) {

            var $sectionsBelow = $section.nextAll('.section');

            $sectionsBelow.each(function(i, section) {

                var $sectionBelow = $(section),
                    $nextSection = $sectionBelow.next('.section');

                animateSection($sectionBelow, $nextSection, 'up');
/*
                if ($sectionBelow.find('.slide').length > 0) {
                    $sectionBelow.find('.slide').each(function(j, slide) {

                        var $slide = $(slide),
                            $nextSlide = $slide.next('.slide');

                        animateSection($slide, $nextSlide, 'up');
                    });
                }
 *//*
            });
        }*/
    }

    // слушать свайпы у объектов, которые не свайпаются по умолчанию
    $('.js-custom-swipe').each(function (i, element) {
        const swiper = new Swipe(element),
            $element = $(element);

        swiper.onDown(function() {
            if ($element.closest('.slide').length > 0) {
                window.fullpage_api.moveSlideRight();
            } else {
                window.fullpage_api.moveSectionUp();
            }
        });

        swiper.onUp(function() {
            if ($element.closest('.slide').length > 0) {
                window.fullpage_api.moveSlideLeft();
            } else {
                window.fullpage_api.moveSectionDown();
            }
        });

        swiper.run();
    });

    $('.js-section-add-animation-class-on-enter').each(function() {

        var $section = $(this),
            controller = new SectionController($section);

        $section.addClass(CLASS_SECTION_WILL_BE_ANIMATED);

        controller.animateOnEnter = function() {
            $section.addClass('section-animation-on-enter');
            sectionHasBeenAnimated(controller.id, 'section-animation-on-enter')
        };

        controller.revertAnimateOnEnter = function() {
            $section.removeClass('section-animation-on-enter');
            sectionAnimationHasBeenReverted(controller.id)
        };

        $section.data('controller', controller);
    });

    $('.js-section-add-animation-class-on-leave').each(function() {

        var $section = $(this),
            controller = new SectionController($section);

        $section.addClass(CLASS_SECTION_WILL_BE_ANIMATED);

        controller.animateOnLeave = function() {
            $section.addClass('section-animation-on-leave');
            sectionHasBeenAnimated(controller.id, 'section-animation-on-leave')
        };

        controller.revertAnimateOnLeave = function() {
            $section.removeClass('section-animation-on-leave');
            sectionAnimationHasBeenReverted(controller.id)
        };

        $section.data('controller', controller);
    });

    function sectionHasBeenAnimated(sectionId, animation) {

        // ждем пока загрузится fullpage
        if (fullpageFirstLoad) {
            return;
        }

        animatedSections[(new Date).getTime()] = sectionId;
    }

    function sectionAnimationHasBeenReverted(sectionId, animation) {

        for (let index in animatedSections) {
            if (animatedSections[index] === sectionId) {
                delete(animatedSections[index]);
            }
        }

        //console.log('delete animation', sectionId);
        //console.table(animatedSections);
    }

})
